<template>
  <Addition v-if="isAddition">
    <template #field>{{ change.field.name }}</template>
    <p>{{ newValueName }}</p>
  </Addition>
  <Removal v-else-if="isRemoval">
    <template #field>{{ change.field.name }}</template>
    <p class="old-value">{{ oldValueName }}</p>
  </Removal>
  <Change v-else-if="isChange">
    <template #field>{{ change.field.name }}</template>
    <template #old>
      <p>{{ oldValueName }}</p>
    </template>
    <template #new>
      <p class="new-value">{{ newValueName }}</p>
    </template>
  </Change>
</template>

<script>
import { EXTERNAL_CHANGES_TYPE } from "@/enums/external-changes";

import Addition from "@/components/ExternalChanges/general/Addition.vue";
import Removal from "@/components/ExternalChanges/general/Removal.vue";
import Change from "@/components/ExternalChanges/general/Change.vue";

export default {
  name: "CategoryChange",
  props: {
    change: {
      type: Object,
      required: true
    }
  },
  components: { Addition, Removal, Change },

  computed: {
    isAddition() {
      return this.change && this.change.type
        ? this.change.type === EXTERNAL_CHANGES_TYPE.ADDITION &&
            this.change.new_value &&
            this.change.new_value.name
        : false;
    },
    isRemoval() {
      return this.change && this.change.type
        ? this.change.type === EXTERNAL_CHANGES_TYPE.REMOVAL &&
            this.change.old_value &&
            this.change.old_value.name
        : false;
    },
    isChange() {
      return this.change && this.change.type
        ? this.change.type === EXTERNAL_CHANGES_TYPE.CHANGE &&
            this.change.new_value &&
            this.change.new_value.name &&
            this.change.old_value &&
            this.change.old_value.name
        : false;
    },
    isCurrentLanguageDifferentThanPl() {
      return this.currentLanguage !== "pl";
    },
    newValueName() {
      return this.isCurrentLanguageDifferentThanPl &&
        this.change.new_value.name_en
        ? this.change.new_value.name_en
        : this.change.new_value.name;
    },
    oldValueName() {
      return this.isCurrentLanguageDifferentThanPl &&
        this.change.old_value.name_en
        ? this.change.old_value.name_en
        : this.change.old_value.name;
    }
  }
};
</script>

<style lang="scss" scoped>
.new-value {
  font-weight: bold;
}

.old-value {
  text-decoration: line-through;
}
</style>
